export default __webpack_public_path__ + "static/media/love.c794cc57.svg";